import './carkeyvisual.scss';

import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import Slider from 'react-slick';
import { KiaContext } from '../../../common/context/main.context';

export default function Carousel() {
    const { prefix, carouselData } = useContext(KiaContext);

    // Slick carousel settings
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        pauseOnHover: true,
        arrows: false,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    // arrows: false,
                    dots: true
                }
            }
        ]
    };


    if (!carouselData || carouselData.length === 0) {
        return (
            <></>
        );
    }

    return (
        <div className="carkeyvisual carousel-container">
            <Slider {...settings}>
                {carouselData.map((slide) => {
                    const rawCtaLink = typeof slide.ctaLink === 'string' ? slide.ctaLink.trim() : '';
                    const isAbsoluteUrl = /^https?:\/\//i.test(rawCtaLink);
                    const ctaLink = isAbsoluteUrl ? rawCtaLink : `${prefix}${rawCtaLink}`;

                    return (
                        <div key={slide.id} className="carousel-slide">
                            <div className="carousel-image">
                                <picture>
                                    <source
                                        media="(max-width: 768px)"
                                        srcSet={slide.imageMobile}
                                    />
                                    <img
                                        src={slide.imageDesktop}
                                        alt={slide.title}
                                    />
                                </picture>
                            </div>
                            <div className="carousel-content">
                                <div className="carousel-content-inner">
                                    <h2 className="carousel-title">{slide.title}</h2>
                                    <div className="carousel-description" dangerouslySetInnerHTML={{ __html: slide.description }} />
                                    {isAbsoluteUrl ? (
                                        <a href={ctaLink} className="carousel-cta" target="_blank" rel="noopener noreferrer">
                                            {slide.ctaText}
                                        </a>
                                    ) : (
                                        <Link to={ctaLink} className="carousel-cta">
                                            {slide.ctaText}
                                        </Link>
                                    )}
                                </div>
                            </div>
                        </div>
                    );
                })}
            </Slider>
        </div>
    );
}